import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';

import { postLogout } from '@perpay-web/fintech/actions/authentication';
import Logout from '@perpay-web/fintech/components/composite/Logout/Logout';
import { authentication } from '@perpay-web/fintech/settings/singletons';
import { getLogoutRedirectPath } from '@perpay-web/fintech/utils/routeUtils';

const BorrowerLogoutContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onMount = useCallback(() => {
        // Check if user is already logged out
        if (!authentication.getIsAuthenticated()) {
            // Already logged out - redirect immediately to next? or /login
            const redirectPath = getLogoutRedirectPath();
            navigate(redirectPath, { replace: true });
            return;
        }
        dispatch(postLogout());
    }, [dispatch, navigate]);

    return <Logout onMount={onMount} />;
};

export default BorrowerLogoutContainer;
